<template src="./index.html"></template>
<script>
import { getdata } from './data.js';
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { noticeExTemplate, noticetemplate, Templatedelete, noticeExTemplateupdate } from '../../../../../src/api/fxtz.js';
export default {
	name: 'tzmb',
	components: {
		quillEditor
	},
	data: function() {
		return {
			tablekey: 0,
			tableData: getdata().tableData,
			headData: getdata().headData,
			pagination: getdata().pagination,
			searchlist: getdata().searchlist,
			searchdiag: false,
			searchdata: getdata().searchdata,
			mblist: getdata().mblist,
			options: null,
			lrdetail: false,
			mbData: [
				// {
				// 	label: '短信'
				// },
				{
					label: '邮箱'
				},
				// {
				// 	label: '钉钉机器人'
				// }
			],
			chooseindex: 1,
			select_show: false,
			disableds: false,
			index: 0,
			list:{
				content: '',
				out: '0',
				title:'',
				name: '',
			},
			id: null,
			textselect: '',
			editorOption: {
				modules: {
					toolbar: [
						['bold', 'italic', 'underline', 'strike', 'link', 'image', 'code-block'], // toggled buttons
						[
							{
								align: []
							}
						], //对齐方式
						[
							{
								header: [1, 2, 3, 4, 5, 6, false]
							}
						], //几级标题
						[
							{
								font: []
							}
						], //字体
						[
							{
								size: ['small', 'normal', 'large', 'huge']
							}
						],
						[
							{
								color: []
							},
							{
								background: []
							}
						] // 字体颜色，字体背景颜色
					]
				}
			}
		};
	},
	created() {},
	mounted() {
		this.fy();
	},
	methods: {
		addmbam() {
			//添加新模板
			this.lrdetail = true;
			this.chooseindex = 0;
			Object.keys(this.list).map(key=>{
				this.list[key] = ''
			})
			this.disableds = false;
			this.id = null;
		},
		nextxz() {
			if(this.list.name==""){
				this.$message.error("请填写模板名称");
				return;
			}
			let {name,content,out,title} = this.list
			let enable = out ? 0 : 1;
			let params = {
				noticeType: 2,
				noticeTemplateName: name,
				noticeTemplateContent: content,
				enable,
				noticeTemplateTitle:title
			};
			if(!this.disableds){
				if (this.id != null) {
					params.id = this.id;
					noticeExTemplateupdate(params).then(res => {
						if (res.data.code == 1) {
							this.lrdetail = false;
							this.fy();
						} else {
							this.$message.error(res.data.msg);
						}
					});
				} else {
					noticetemplate(params).then(res => {
						if (res.data.code == 1) {
							this.lrdetail = false;
							this.fy();
						} else {
							this.$message.error(res.data.msg);
						}
					});
				}
			}else{
				this.lrdetail = false;
			}
			
		},
		textchange(e) {
			// if (e.text[e.text.length - 2] == '#') {
			// 	let b = 0;
			// 	for (let a = 0; a < e.text.length; a++) {
			// 		if (e.text[a] == '#') {
			// 			b++;
			// 		}
			// 	}
			// 	this.index = b;
			// 	let ql = document.getElementsByClassName('ql-container')[0];
			// 	let select = document.getElementsByClassName('el_element_select')[0];
			// 	let left = ql.children[0].children[0].innerHTML.length * 10;
			// 	let children = ql.children[0].children;
			// 	select.style.top = ql.offsetTop + children[children.length - 1].offsetTop + 20 + 'px';
			// 	if (left < 260) {
			// 		select.style.left = left + 'px';
			// 	} else {
			// 		select.style.left = '260px';
			// 	}
			// 	this.select_show = true;
			// 	this.$refs.selectRef.toggleMenu();
			// } else {
			// 	if (this.index >= 1) {
			// 		this.textselect = e.text.split('#')[this.index];
			// 		this.dataFilter(this.textselect);
			// 	}
			// }
		},
		dataFilter(val) {
			if (val) {
				//val存在
				val = val.replace(/\s*/g,"");
				this.options = this.mblist.filter(item => {
					if (!!~item.label.indexOf(val) || !!~item.label.toUpperCase().indexOf(val.toUpperCase())) {
						return true;
					}
				});
			} else {
				//val为空时，还原数组
				this.options = this.mblist;
		 }
		},
		selectChange(e){
			this.content = this.content.slice(3,this.content.length-4)
			this.content = `<p>${this.content}#${this.textselect}</p>`
			this.select_show = false;
			this.textselect = ''
		},
		ont() {
		},
		forseejcxinxi(e, index) {
			if (index == 1) {
				this.disableds = true;
			} else {
				this.disableds = false;
				this.id = e.id;
			}
			this.lrdetail = true;
			this.chooseindex = 0;
			this.list.name = e.noticeTemplateName;
			this.list.title = e.noticeTemplateTitle;
			this.list.out = e.enable == 0 ? true : false;
			this.list.content = e.noticeTemplateContent;
		},
		fy() {
			let params = {
				current: this.pagination.pageNum,
				size: this.pagination.pageSize,
				...this.searchdata
			};
			noticeExTemplate(params).then(res => {
				if (res.data.code == 1) {
					this.pagination.total = res.data.data.total;
					this.tableData = res.data.data.records;
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		del() {
			this.$showConfirm({
				message: '确认删除?'
			}).then(res => {
				if (res == 'confirm') {
					let params = [];
					this.$refs.tablebox.getSelectionval().map(item => {
						params.push(item.id);
					});
					Templatedelete(params).then(res => {
						if (res.data.code == 1) {
							this.fy();
						} else {
							this.$message.error(res.data.msg);
						}
					});
				}
			});
		},
		currentChange(e) {
			this.pagination.pageNum = e;
			this.fy();
		},
		sizechange(e) {
			this.pagination.pageSize = e;
			this.fy();
		},

		submitSearch() {
			this.pagination.pageNum = 1;
			this.pagination.paginationkey++;
			this.fy();
		},
		forUpdateSearch() {
			this.searchdiag = true;
		},
		closeSearch() {
			this.searchdiag = false;
		},
		saveChange(e) {
			this.searchdiag = false;
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
